/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProjectList } from "./ProjectList";
import {
  ProjectListFromJSON,
  ProjectListFromJSONTyped,
  ProjectListToJSON,
  ProjectListToJSONTyped,
} from "./ProjectList";

/**
 *
 * @export
 * @interface PaginatedProjectListList
 */
export interface PaginatedProjectListList {
  /**
   *
   * @type {number}
   * @memberof PaginatedProjectListList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedProjectListList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedProjectListList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ProjectList>}
   * @memberof PaginatedProjectListList
   */
  results: Array<ProjectList>;
}

/**
 * Check if a given object implements the PaginatedProjectListList interface.
 */
export function instanceOfPaginatedProjectListList(
  value: object
): value is PaginatedProjectListList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedProjectListListFromJSON(json: any): PaginatedProjectListList {
  return PaginatedProjectListListFromJSONTyped(json, false);
}

export function PaginatedProjectListListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedProjectListList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] == null ? undefined : json["next"],
    previous: json["previous"] == null ? undefined : json["previous"],
    results: (json["results"] as Array<any>).map(ProjectListFromJSON),
  };
}

export function PaginatedProjectListListToJSON(json: any): PaginatedProjectListList {
  return PaginatedProjectListListToJSONTyped(json, false);
}

export function PaginatedProjectListListToJSONTyped(
  value?: PaginatedProjectListList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ProjectListToJSON),
  };
}
